import axios from 'axios';
import {backendHost} from '../../config';

export const getLandingsById = (params) => {
    return axios.get(`${backendHost}/api/partners/admin/landings/${params.id}`);
};